import React, { createContext, useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getToken,
  removeToken,
  storeToken,
} from "../Data/services/localStorageService";
import { setAuthTokens, clearAuthTokens } from "../Data/features/authSlice";
import { useGetProfileQuery } from "../Data/services/settingApi";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const isAuthenticated = !!token;

  // const { data: userData } = useGetProfileQuery(undefined, {
  //   skip: !token,
  // });

  // useEffect(() => {
  //   if (userData) {
  //     dispatch(setAuthTokens({ token, user: userData.data }));
  //   }
  // }, [userData, token, dispatch]);

  const login = (newToken, user) => {
    storeToken(newToken);
    dispatch(setAuthTokens({ token: newToken, user }));
  };

  const logout = () => {
    removeToken();
    dispatch(clearAuthTokens());
  };

  const value = {
    user: useSelector((state) => state.auth.user),
    token,
    isAuthenticated,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};
